import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { Navbar } from "../../Components/Navbar/Navbar";
import { Meta } from "../../Components/Helpers/Meta";
import { useParams } from "react-router-dom";
import InvestorSidebar from "../../Components/InvestorSidebar/InvestorSidebar";
import { LuDownload } from "react-icons/lu";
import "./AnalystReports.style.css";

const AnalystReports = () => {
    const { t } = useTranslation();
    const { lang } = useParams();

    const formatDate = (isoDate) => {
        const d = new Date(isoDate);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}.${month}.${year}`;
      };
  
    const reports = [
        {
          date: "2025-01-10",
          name: {
            tr: "2025 Ocak Raporu",
            en: "January 2025 Report",
          },
          href: {
            tr: "https://www.cevher.com/static/docs/report-01-tr.pdf",
            en: "https://www.cevher.com/static/docs/report-01-en.pdf",
          },
        },
        {
          date: "2025-02-05",
          name: {
            tr: "2025 Şubat Raporu",
            en: "February 2025 Report",
          },
          href: {
            tr: "https://www.cevher.com/static/docs/report-02-tr.pdf",
            en: "https://www.cevher.com/static/docs/report-02-en.pdf",
          },
        },
      ];
    
      // aktif dil
      const currentLang = i18next.language.startsWith("tr") ? "tr" : "en";
    
      return (
        <div>
          <Meta
            title={t("analyst-reports")}
            description={t("analyst-reports")}
            lang={lang}
          />
          <Navbar />
    
          <div className="c-wrapper">
            <div className="c-hero">
              <div className="c-hero-background">
                <picture>
                  <img
                    className="c-hero-image"
                    alt=""
                    src={require("../../assets/hero/public-offering.jpg")}
                    style={{ width: "100%" }}
                  />
                </picture>
              </div>
              <div className="c-hero-body">
                <div className="c-about-caption">
                  <div
                    className="c-caption-section"
                    style={{ color: "#000", textAlign: "center" }}
                  >
                    {t("investor-relations")}
                  </div>
                  <h1 className="c-caption-header" style={{ color: "#000" }}>
                    {t("analyst-reports")}
                  </h1>
                </div>
              </div>
            </div>
    
            {/* İçerik */}
            <div className="po-container">
              <InvestorSidebar />
    
              <main className="po-content">
  <div className="po-card">
    {/* Başlık */}
    <div className="po-table-head">
      <span>{t("date")}</span>
      <span>{t("report-name")}</span>
      <span aria-hidden="true"></span>{/* ikon sütunu (boş başlık) */}
    </div>

    {/* Satırlar */}
    <ul className="po-table">
      {reports.map((r, i) => (
        <li key={i} className="po-table-row">
          <span className="po-date">{formatDate(r.date)}</span>
          <span className="po-report-title">
            {r.name[currentLang] || r.name.en}
          </span>
          <a
            href={r.href[currentLang] || r.href.en}
            target="_blank"
            rel="noreferrer"
            aria-label="Download report"
            className="po-doc-dl"
          >
            <LuDownload size={18} />
          </a>
        </li>
      ))}
    </ul>
  </div>
</main>

            </div>
          </div>
        </div>
      );
    };

export default AnalystReports;
